import { type ChangeEvent } from "react";

import { type ReferencedTextAreaValue } from "@doitintl/cmp-models";
import noop from "lodash/noop";

export type InputWithChipsElement = HTMLDivElement & { value: ReferencedTextAreaValue };

export class ReferencedTextAreaChangeEvent implements ChangeEvent<InputWithChipsElement> {
  public readonly target: InputWithChipsElement;

  public readonly currentTarget: InputWithChipsElement;

  public readonly bubbles: boolean = true;

  public readonly cancelable: boolean = true;

  public readonly defaultPrevented: boolean = false;

  public readonly eventPhase: number = 0;

  public readonly isTrusted: boolean = true;

  public readonly nativeEvent: Event;

  public isDefaultPrevented: () => boolean = () => false;

  public isPropagationStopped: () => boolean = () => false;

  public persist: () => void = noop;

  public preventDefault: () => void = noop;

  public stopPropagation: () => void = noop;

  public readonly timeStamp: number;

  public readonly type: string = "change";

  constructor(target: InputWithChipsElement, value: ReferencedTextAreaValue) {
    target.value = value;

    this.target = target;
    this.currentTarget = target;

    this.nativeEvent = new Event("change", { bubbles: true });
    this.timeStamp = Date.now();
  }
}
